// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let QueryParams = require("../../../reason/QueryParams.bs.js");

let config = Object.fromEntries([[
    "draftId",
    QueryParams.UseQueryParams.ParamConfigs.numberParam
  ]]);

let ParamsConfig = {
  config: config
};

let UseQueryParams = QueryParams.UseQueryParams.Make(ParamsConfig);

let use = UseQueryParams.use;

exports.ParamsConfig = ParamsConfig;
exports.UseQueryParams = UseQueryParams;
exports.use = use;
/* config Not a pure module */
